import '../filter_view.js.coffee'

Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.CustomFacetsFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/custom_facet/custom_facets_filter"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet

  render: ->
    @$el.html(@template())
    _.each @facet['custom_facets'], (values, key) =>
      if !@searchQuery.get('custom_facets')[key] || @searchQuery.get('custom_facets')[key].length == 0
        @$el.append new GenericFacetFilterView($.extend({ name: key, values: values}, @options)).render().el
    return this

  destroy: ->
    this.remove()
    return false

class GenericFacetFilterView extends Monitoring.Views.SocialContents.Filters.FilterView

  initialize: (@options = {}) ->
    super
    @name = @options.name
    @alias = _.str.humanize(@name)

  render: ->
    @$el.html(@template(self: this, facets: @options.values.terms)) if @options.values.terms.length > 0
    return this

  getFacet: ->
    @options.values

  getDescription: (facet) ->
    facet.term

  addFilter: (value) ->
    @searchQuery.addCustomFacet(@name, value)
